import { render, staticRenderFns } from "./SecretAdminConfigPage.vue?vue&type=template&id=7ab090b2&scoped=true"
import script from "./SecretAdminConfigPage.vue?vue&type=script&lang=js"
export * from "./SecretAdminConfigPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ab090b2",
  null
  
)

export default component.exports